import { v4 as uuidv4 } from 'uuid'

export const carriers = [...new Array(5)].map((_: any, index: number) => ({
  id: uuidv4(),
  name: 'Carrier Code ' + ++index,
  __typename: 'Carrier'
}))
